import { useFilterContext } from './FilterContext';

export const useSeeAllFilterEntry = (id: string, expandableResults = false) => {
    const { seeAllFilterEntries, setSeeAllFilterEntries } = useFilterContext();

    const toggleSeeAll = () => {
        if (seeAllFilterEntries.includes(id)) {
            setSeeAllFilterEntries(seeAllFilterEntries.filter(item => item !== id));
        } else {
            setSeeAllFilterEntries([...seeAllFilterEntries, id]);
        }
    };

    return {
        seeAll: seeAllFilterEntries.includes(id),
        toggleSeeAll
    };
};
